import React, { useState, useEffect, useCallback } from "react";
import publicAxios from "../../utils/publicAxios";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import {
  showToast,
  isValidPhoneLength,
  isRecaptchaEnabled
} from "../../utils/utils";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import {
  FaEye,
  FaEyeSlash,
  FaCheck,
  FaInfoCircle,
  FaExclamationTriangle
} from "react-icons/fa";
import "./../../assets/scss/login.scss";
import Footerweb from "../../components/layout/footer/Footerweb";
import Headerweb from "../../components/layout/header/Headerweb";
import useMixpanelEventAction from "../../config/mixpanel/useMixpanelEventAction";
import GA4EventAction from "../../config/GoogleAnalytics/useGA4EventAction";
import {
  profiletexts,
  signup,
  login,
  processing,
  passwordtext,
  Inputfieldvalidation,
  commonErrMsg
} from "../../locales/en";
import {
  ALLOWED_KEYS,
  AREA_CODES,
  AU_PHONE_REGEX,
  COUNTRY_CODE_AU_SMALL,
  COUNTRY_CODE_NZ,
  COUNTRY_CODE_NZ_SMALL,
  DIGIT_REGEX,
  EMAIL_REGEX_SIMPLE,
  ESCAPE_REGEX,
  INDIAN_CURRENCY,
  IP_API_URL,
  LOWERCASE_REGEX,
  NAME_REGEX,
  NZ_PHONE_REGEX,
  PH_LENGTH_11,
  PH_LENGTH_13,
  REMOVE_NON_DIGIT_REGEX,
  showToastType,
  SINGLE_DIGIT_REGEX,
  UPPERCASE_REGEX,
  WHITESPACE_REGEX
} from "../../utils/constants/appConstants";
import {
  RECAPTCHA_ERROR,
  EXPIRY_ERROR
} from "../../utils/constants/appConstants";
import { getFetchCountryCodeURL } from "../../utils/constants/apiEndPoints";
import { getRegisterUrl } from "../../utils/constants/apiEndPoints";
import { INVOICE } from "../../route/paths";
import { buildUtmHistory } from "../../utils/hubspotUtils";
import {
  buildMarketingIdentifiers,
  clearStoredAdClickIds
} from "../../utils/marketingIdentifiers";
import { NAVIGATION_SOURCE } from "../../utils/constants/navigationConstants";
import {
  setDisconnectConnectedSoftwareData,
  setGetConnectedSoftwareData,
  setOnboardingData
} from "../../redux/loginSlice";
import { useDispatch } from "react-redux";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const Signup = () => {
  const dispatch = useDispatch();
  const environment = process.env.REACT_APP_ENV;
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { signupMixpanelEvent } = useMixpanelEventAction();
  const { signupGA4Event } = GA4EventAction();
  const [selectCountry, setSelectCountry] = useState(COUNTRY_CODE_AU_SMALL);
  const [country, setCountry] = useState(COUNTRY_CODE_AU_SMALL);
  const [validatePhnumber, setValidatePhnumber] = useState(false);
  const { promoCode, referralPromoUsageHistoryId } = useParams();
  const initialLoading = {
    signUpBtn: false
  };
  const initialValue = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
    showPassword: false,
    error: ""
  };
  const initialErrors = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
    invalidOTPMessage: "",
    submit: ""
  };

  const [loading, setLoading] = useState(initialLoading);
  const [values, setValues] = useState(initialValue);
  const [errors, setErrors] = useState(initialErrors);

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const referralCode = searchParams.get("referral_code");

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const fetchUserLocation = useCallback(async () => {
    try {
      const response = await fetch(IP_API_URL);
      const data = await response.json();
      if (data.country_code === COUNTRY_CODE_NZ) {
        setCountry(COUNTRY_CODE_NZ_SMALL);
      } else {
        setCountry(COUNTRY_CODE_AU_SMALL);
      }
    } catch {
      //handle error
    }
  }, []);

  const handleInputChange = (field, value) => {
    setValues({ ...values, [field]: value });
  };

  const fetchCountryCode = useCallback(async (phoneNumber, country) => {
    try {
      const response = await publicAxios.get(getFetchCountryCodeURL, {
        params: { number: phoneNumber, countryCode: country }
      });
      if (response.status === 200) {
        setValidatePhnumber(true);
      } else {
        setValidatePhnumber(false);
      }
    } catch {
      setValidatePhnumber(false);
    }
  }, []);

  const selectedCountry = (phoneNumber) => {
    const countryCode = phoneNumber.slice(0, 2);
    let country = null;
    if (countryCode === "61") {
      country = "au";
    } else if (countryCode === "64") {
      country = "nz";
    }
    return country;
  };

  const requestPhoneNumber = (phoneNumnber) => {
    const result = phoneNumnber.slice(2).replace(/[()-\s]/g, "");
    return result;
  };

  const handlePhInputChange = (field, value, countryCode) => {
    setValues({ ...values, [field]: value });
    setValidatePhnumber(false);

    if (selectCountry !== countryCode) {
      const result = validateField(field, value);
      if (result !== "") return;
      const phoneNumber = requestPhoneNumber(value);
      fetchCountryCode(phoneNumber, selectedCountry(value));
    }
  };

  const handleBlur = (field, value) => {
    setValues((prevValues) => ({
      ...prevValues,
      [field]: value
    }));
    // Trigger validation for the specific field
    const result = validateField(field, value);
    if (result !== "") return;
    const phoneNumber = requestPhoneNumber(values.phoneNumber);
    if (phoneNumber && phoneNumber !== value) {
      fetchCountryCode(phoneNumber, selectedCountry(value));
    }
  };
  const validateField = (field, value) => {
    let error = "";
    switch (field) {
      case "firstName":
        if (value.trim().length === 0) {
          error = profiletexts?.errorMessage.firstNameRequired;
        } else if (!NAME_REGEX.test(value)) {
          error = signup?.errors.firstnameErr;
        } else if (value.trim().length < 2 || value.trim().length > 50) {
          error = Inputfieldvalidation.errorMsg.firstNameLength;
        }
        break;

      case "lastName":
        if (value.trim().length === 0) {
          error = profiletexts?.errorMessage.lastNameRequired;
        } else if (!NAME_REGEX.test(value)) {
          error = signup?.errors.lastnameErr;
        } else if (value.trim().length < 2 || value.trim().length > 50) {
          error = Inputfieldvalidation.errorMsg.lastNameLength;
        }
        break;

      case "email":
        if (value.length > 100) {
          error = login?.errorMSG.emailLong;
        } else {
          error = EMAIL_REGEX_SIMPLE.test(value)
            ? ""
            : login?.errorMSG.enterEmail;
        }
        break;

      case "phoneNumber": {
        const trimmedValue = value.replace(WHITESPACE_REGEX, "");
        const numericValue = value.trim().replace(/[^\d]/g, "");

        if (
          AU_PHONE_REGEX.test(trimmedValue) ||
          NZ_PHONE_REGEX.test(trimmedValue)
        ) {
          error = signup?.errors.startnumber;
        } else if (
          trimmedValue === "61" ||
          trimmedValue === "64" ||
          trimmedValue === ""
        ) {
          error = signup?.errors?.numberRequired;
        } else if (!isValidPhoneLength(numericValue)) {
          error = profiletexts?.errorMessage.primaryContactError;
        }
        break;
      }

      case "password":
        {
          const firstName = values.firstName.trim().toLowerCase();
          const emailPrefix = values.email.split("@")[0].trim().toLowerCase();
          const passwordLower = value.toLowerCase();

          if (!value || value.trim().length === 0) {
            error = signup?.errors.passRequired;
          } else if (value.length < 8 || value.length > 50) {
            error = Inputfieldvalidation.errorMsg.passwordLength;
          } else if (
            (firstName && passwordLower.startsWith(firstName)) ||
            (emailPrefix && passwordLower.startsWith(emailPrefix))
          ) {
            error = Inputfieldvalidation.errorMsg.passwordStartWithPart;
          } else {
            const passwordErrors = [];
            if (value.includes(INDIAN_CURRENCY)) {
              passwordErrors.push(
                <small key="indian-currency" className="mt-1 d-block">
                  <FaInfoCircle className="me-1" />
                  {passwordtext?.passwordNotOk}
                </small>
              );
            }
            if (!DIGIT_REGEX.test(value)) {
              passwordErrors.push(
                <small key="digit" className="mt-1 d-block">
                  <FaInfoCircle className="me-1" />
                  {signup?.passValidation.rule2}
                </small>
              );
            }
            if (!UPPERCASE_REGEX.test(value)) {
              passwordErrors.push(
                <small key="uppercase" className="mt-1 d-block">
                  <FaInfoCircle className="me-1" />
                  {signup?.passValidation.rule3}
                </small>
              );
            }
            // Add lowercase check
            if (!LOWERCASE_REGEX.test(value)) {
              passwordErrors.push(
                <small key="lowercase" className="mt-1 d-block">
                  <FaInfoCircle className="me-1" />
                  {signup?.passValidation?.rule5}
                </small>
              );
            }
            if (!ESCAPE_REGEX.test(value)) {
              passwordErrors.push(
                <small key="special" className="mt-1 d-block">
                  <FaInfoCircle className="me-1" />
                  {signup?.passValidation.rule4}
                </small>
              );
            }
            error =
              passwordErrors.length > 0 ? (
                <>
                  {passwordErrors.map((item, index) => (
                    <React.Fragment key={index}>{item}</React.Fragment>
                  ))}
                </>
              ) : (
                <small className="primary-color">
                  <FaCheck className="me-1" />
                  {passwordtext?.okPassword}
                </small>
              );
          }
        }
        break;

      default:
        break;
    }

    // Flatten non-React errors
    if (typeof error === "object" && !React.isValidElement(error)) {
      error = Object.values(error).flat().join(", ");
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [field]: error
    }));

    return error;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const firstNameError = validateField("firstName", values.firstName);
    const lastNameError = validateField("lastName", values.lastName);
    const emailError = validateField("email", values.email);
    const phoneNumberError = validateField("phoneNumber", values.phoneNumber);
    const passwordError = validateField("password", values.password);
    const errors = {
      firstName: firstNameError,
      lastName: lastNameError,
      email: emailError,
      phoneNumber: phoneNumberError,
      password: passwordError,
      recaptcha: ""
    };

    setErrors(errors);

    // Check if any errors exist
    const hasErrors = Object.values(errors).some((error) => error.length > 0);
    if (hasErrors) {
      return;
    }

    let recaptchaToken = null;

    if (isRecaptchaEnabled(environment)) {
      if (!executeRecaptcha) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          recaptcha: commonErrMsg?.RecaptchaError
        }));
        return;
      }
      recaptchaToken = await executeRecaptcha("signup");
    }

    if (isRecaptchaEnabled(environment)) {
      if (!recaptchaToken) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          recaptcha: login?.errorMSG.recaptcha
        }));
        return;
      }
    }

    // Convert the phone number to E.164 format
    const e164PhoneNumber = `+${values.phoneNumber.replace(/\D/g, "")}`;

    try {
      const userdataentry = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        primaryContactNumber: e164PhoneNumber,
        password: values.password.trim(),
        recaptchaResponse: recaptchaToken,
        referralCode: referralCode || null,
        promoCode: promoCode || null,
        referralPromoUsageHistoryId: referralPromoUsageHistoryId || null,
        utmHistory: buildUtmHistory(),
        marketingIdentifiers: buildMarketingIdentifiers()
      };

      setLoading((prev) => ({ ...prev, signUpBtn: true }));
      const response = await publicAxios.post(getRegisterUrl, userdataentry);

      if (response.status === 200 || response.status === 201) {
        showToast(response.data.message, showToastType.success);
        // The registered account owns the ad click that was stored for it, so it is forgotten
        // here rather than credited again to whoever signs up next on this browser.
        clearStoredAdClickIds();
        signupMixpanelEvent(response?.data?.data);
        signupGA4Event(response?.data?.data, promoCode, referralCode);
        navigate(INVOICE, {
          state: { source: NAVIGATION_SOURCE.SIGNUP }
        });
        dispatch(setOnboardingData({}));
        dispatch(setDisconnectConnectedSoftwareData(null));
        dispatch(setGetConnectedSoftwareData({}));
      } else {
        setErrors({ ...errors, submit: response.data.errors });
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 400) {
          const { message, errors } = error.response.data;
          if (message !== "Validation failed") {
            const errorMessages = Object.values(errors)
              .flatMap((fieldErrors) => {
                if (Array.isArray(fieldErrors)) {
                  return fieldErrors.flat();
                } else if (
                  typeof fieldErrors === "object" &&
                  fieldErrors !== null
                ) {
                  return Object.values(fieldErrors).flat();
                }
                return String(fieldErrors);
              })
              .join("\n");
            setErrors((prevErrors) => ({
              ...prevErrors,
              password: errorMessages ? (
                <small className="mt-1 d-block">
                  <FaExclamationTriangle className="me-1" />
                  {errorMessages}
                </small>
              ) : (
                <small className="primary-color">
                  <FaCheck className="me-1" />
                  {passwordtext?.okPassword}
                </small>
              )
            }));
          } else {
            const normalizeValue = (val) => {
              if (Array.isArray(val)) return val;
              if (typeof val === "object" && val !== null)
                return Object.values(val).flat(Infinity);
              return [val];
            };
            const errorMessages = Array.isArray(errors)
              ? errors.flatMap(normalizeValue).join("\n")
              : String(errors);
            showToast(errorMessages, showToastType.error);
          }
        } else if (error.response.status === 403) {
          setErrors({ ...errors, submit: error.response.data.message });
        } else if (
          error.response.status === 409 ||
          error.response.status === 500
        ) {
          setErrors({ ...errors, submit: error.response.data.errors });
        } else if (error.response.status === 406) {
          const apiErrors = error.response.data.errors || [];

          if (apiErrors.some((err) => err.includes(RECAPTCHA_ERROR))) {
            setErrors((prev) => ({
              ...prev,
              submit: error.response.data.errors[0]
            }));
            return;
          }

          if (apiErrors.some((err) => err.includes(EXPIRY_ERROR))) {
            setErrors((prev) => ({
              ...prev,
              submit: error.response.data.message
            }));
            return;
          }
        } else {
          setErrors({ ...errors, submit: error.response.data.message });
        }
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          submit: login?.errorMSG.somethingWrong
        }));
      }
    } finally {
      setLoading((prev) => ({ ...prev, signUpBtn: false }));
    }
  };

  useEffect(() => {
    fetchUserLocation();
  }, [fetchUserLocation]);

  const handlePhoneKeyDown = (e) => {
    const input = e.target;

    if (ALLOWED_KEYS.includes(e.key)) {
      return;
    }

    if (!SINGLE_DIGIT_REGEX.test(e.key)) {
      return;
    }

    const digits = input.value.replace(REMOVE_NON_DIGIT_REGEX, "");
    const maxLength = digits.startsWith(AREA_CODES?.nz)
      ? PH_LENGTH_13
      : PH_LENGTH_11;
    const hasSelection = input.selectionStart !== input.selectionEnd;
    if (digits.length >= maxLength && !hasSelection) {
      e.preventDefault();
    }
  };

  return (
    <>
      <Headerweb />
      <main>
        <div className="signup-hero-section">
          <div className="container-wrap">
            <div className="hero-content">
              <h1>
                <strong>{login?.mainTitle1}</strong> {login?.mainTitle2}
                <strong>{login?.mainTitle3}</strong>
              </h1>
            </div>
          </div>
        </div>
        <div className="sign-up-wrap">
          <div className="container-wrap">
            <div className="col-row">
              <div className="left-section">
                <div className="about-content">
                  <h4>
                    {login?.text1p1}
                    <strong>{login?.text1p2}</strong> {login?.text1p3}
                  </h4>
                  <p>
                    {login?.text2p1} <br />
                    {login?.text2p2}
                  </p>
                </div>
              </div>
              <div className="right-section">
                <div className="sign-up-form">
                  <div className="fundtap-heading">
                    <h2>{signup?.signupBox.subH2}</h2>
                  </div>

                  <form id="signup_form">
                    <div className="input-row">
                      <div className="left-col">
                        <div className="input-group">
                          <label htmlFor="first_name">
                            {signup?.signupBox.firstname}
                          </label>
                          <input
                            id="first_name"
                            type="text"
                            placeholder="Alexan"
                            name="first_name"
                            onChange={(e) =>
                              handleInputChange("firstName", e.target.value)
                            }
                            onBlur={(e) =>
                              validateField("firstName", e.target.value)
                            }
                            value={values.firstName}
                            autoComplete="true"
                          />
                          {errors.firstName && (
                            <p className="error-message">
                              <small>{errors.firstName}</small>
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="right-col">
                        <div className="input-group">
                          <label htmlFor="last_name">
                            {signup?.signupBox.lastName}
                          </label>
                          <input
                            id="last_name"
                            type="text"
                            placeholder="Doe"
                            name="last_name"
                            onChange={(e) =>
                              handleInputChange("lastName", e.target.value)
                            }
                            onBlur={(e) =>
                              validateField("lastName", e.target.value)
                            }
                            value={values.lastName}
                            autoComplete="true"
                          />
                          {errors.lastName && (
                            <p className="error-message">
                              <small>{errors.lastName}</small>
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="input-row">
                      <div className="input-group">
                        <label htmlFor="email">
                          {signup?.signupBox.emailAddress}
                        </label>
                        <input
                          id="email"
                          type="email"
                          placeholder="alexandoe@example.com"
                          name="email"
                          onChange={(e) =>
                            handleInputChange("email", e.target.value)
                          }
                          onBlur={(e) => validateField("email", e.target.value)}
                          value={values.email}
                          autoComplete="true"
                        />
                        {errors.email && (
                          <p className="error-message">
                            <small>{errors.email}</small>
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="input-row">
                      <div className="input-group">
                        <label htmlFor="phone_number">
                          {signup?.signupBox.phoneNumber}
                        </label>
                        <PhoneInput
                          inputProps={{
                            name: "phone_number",
                            id: "phone_number",
                            onKeyDown: handlePhoneKeyDown
                          }}
                          className="ph-with-country-code"
                          country={country}
                          value={values.phoneNumber}
                          countryCodeEditable={false}
                          onlyCountries={["nz", "au"]}
                          areaCodes={{ au: ["61"], nz: ["64"] }}
                          masks={{ au: "(..) .... ...", nz: "(..) .... ....." }}
                          onChange={(value, event) => {
                            setSelectCountry(event.countryCode);
                            handlePhInputChange(
                              "phoneNumber",
                              value,
                              event.countryCode
                            );
                          }}
                          onBlur={() =>
                            handleBlur("phoneNumber", values.phoneNumber)
                          }
                        />
                        {validatePhnumber && (
                          <p className="error-message">
                            <small className="primary-color">
                              <small>
                                <FaCheck /> {signup?.signupBox.phoneOkay}
                              </small>
                            </small>
                          </p>
                        )}
                        {errors.phoneNumber && (
                          <p className="error-message">
                            <small>{errors.phoneNumber}</small>
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="input-row">
                      <div className="input-group">
                        <label htmlFor="password">
                          {signup?.signupBox.createPass}
                        </label>
                        <div className="passowrd-show">
                          <input
                            id="password"
                            name="password"
                            type={values.showPassword ? "text" : "password"}
                            onChange={(e) =>
                              handleInputChange("password", e.target.value)
                            }
                            onBlur={(e) =>
                              validateField("password", e.target.value)
                            }
                            value={values.password}
                            placeholder="at least 8 characters"
                            autoComplete="false"
                          />
                          <button
                            type="button"
                            className="password-icon"
                            onClick={handleClickShowPassword}
                          >
                            {values.showPassword ? <FaEyeSlash /> : <FaEye />}
                          </button>
                        </div>
                        {errors.password && (
                          <p className="error-message">
                            <small>{errors.password}</small>
                          </p>
                        )}
                      </div>
                    </div>
                    {errors.reCaptcha && (
                      <div className="error-message error-message-gray">
                        <small>{errors.reCaptcha}</small>
                      </div>
                    )}

                    <div className="input-row">
                      <div className="input-group">
                        <button
                          type="submit"
                          className="btn-primary"
                          onClick={handleSubmit}
                          disabled={loading.signUpBtn}
                        >
                          {loading.signUpBtn
                            ? processing
                            : signup?.getFundingBtn}
                        </button>
                      </div>
                    </div>

                    {errors.invalidOTPMessage && (
                      <p className="error-message">
                        <small>{errors.invalidOTPMessage}</small>
                      </p>
                    )}
                    {errors.submit && (
                      <div className="error-message error-message-gray mt-2">
                        {errors.submit}
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footerweb />
    </>
  );
};

export default Signup;
